import firebase from "firebase/app";
import 'firebase/firestore' 
import 'firebase/storage'
import 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyDkopZD2GEOsP4GiBGZBlerNVPdasyjm1k",
    authDomain: "juegoepm-1fa13.firebaseapp.com",
    projectId: "juegoepm-1fa13",
    storageBucket: "juegoepm-1fa13.appspot.com",
    messagingSenderId: "88649929805",
    appId: "1:88649929805:web:a164e1cd463641a5233804"
};

firebase.initializeApp(firebaseConfig);
  
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
  
export { firebase ,  db , auth , storage }
